// Model.js
// -----------------------
// @module Case
define("Anchorgroup.CheckoutCustomization.CheckoutCustomization.Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
});
});
